import { render, staticRenderFns } from "./CountryGroupTable.vue?vue&type=template&id=10e45f42&scoped=true"
import script from "./CountryGroupTable.vue?vue&type=script&lang=js"
export * from "./CountryGroupTable.vue?vue&type=script&lang=js"
import style0 from "./CountryGroupTable.vue?vue&type=style&index=0&id=10e45f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e45f42",
  null
  
)

export default component.exports